import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase/app'
import './registerServiceWorker'
import KeenUI from 'keen-ui'
import 'keen-ui/dist/keen-ui.css'

Vue.config.productionTip = false
Vue.use(KeenUI)


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDR6baGFyatDiwrbYA9QiXbMUIBQ8VExvY",
  authDomain: "eamportal.firebaseapp.com",
  databaseURL: "https://eamportal.firebaseio.com",
  projectId: "eamportal",
  storageBucket: "eamportal.appspot.com",
  messagingSenderId: "817212079183",
  appId: "1:817212079183:web:fc0dc66bdac4875388be3a",
  measurementId: "G-N186CGQWQX"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

let app = null

firebase.auth().onAuthStateChanged(() => {
  if(!app){
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  }
})


